import { render, staticRenderFns } from "./LogGeneral.vue?vue&type=template&id=8cc6dbf4&"
import script from "./LogGeneral.js?vue&type=script&lang=js&"
export * from "./LogGeneral.js?vue&type=script&lang=js&"
import style0 from "./LogGeneral.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports